import validates from 'helpers/validates'

import constants from 'constants/index'

const { STRING_SCHEMA_TYPE } = constants.validations

const richTextRequired = {
  name: 'richTextRequired',
  schemaType: STRING_SCHEMA_TYPE,
  method(message = 'Preencha esse campo') {
    return this.required(message).test(
      'hasContent',
      message,
      validates.jodit.hasContent,
    )
  },
}

export default richTextRequired
